import { Component, OnInit } from '@angular/core';
import { SigCodeService } from '../../services/sig-code.service';
import { SharedService } from '../../services/shared.service';
import { ISigCodeDto, ISigCodePagedResultDto, ISigCodeCreateUpdateRequest } from '../../interfaces/Kroll/isig-code-dto';

declare var bootstrap: any;

@Component({
  selector: 'app-sig-codes',
  templateUrl: './sig-codes.component.html',
  styleUrls: ['./sig-codes.component.css']
})
export class SigCodesComponent implements OnInit {
  result: ISigCodePagedResultDto = { items: [], totalCount: 0 };
  loading = false;
  page = 1;
  pageSize = 25;
  searchSigCode = '';
  searchDescription = '';
  includeDeleted = true;

  editingItem: ISigCodeDto | null = null;
  isCreate = false;
  formSigCode = '';
  formDescription = '';
  formIsDeleted = false;
  showErrorMessage = false;
  errorMessage = '';

  constructor(
    private sigCodeService: SigCodeService,
    private sharedService: SharedService
  ) {}

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.load();
  }

  load() {
    this.loading = true;
    this.showErrorMessage = false;
    this.sigCodeService
      .getSigCodes(this.page, this.pageSize, this.searchSigCode, this.searchDescription, this.includeDeleted)
      .subscribe({
        next: (data) => {
          const raw = data || {};
          const list = raw['items'] || raw['Items'] || [];
          this.result = {
            items: list.map((it: any) => ({
              id: it['id'] != null ? it['id'] : it['Id'],
              sigCode: it['sigCode'] != null ? it['sigCode'] : it['SigCode'],
              description: it['description'] != null ? it['description'] : it['Description'],
              createdDate: it['createdDate'] || it['CreatedDate'],
              updatedDate: it['updatedDate'] || it['UpdatedDate'],
              isDeleted: it['isDeleted'] != null ? it['isDeleted'] : it['IsDeleted']
            })),
            totalCount: raw['totalCount'] != null ? raw['totalCount'] : (raw['TotalCount'] != null ? raw['TotalCount'] : 0)
          };
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Failed to load Sig Codes.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 8000);
        }
      });
  }

  onSearch() {
    this.page = 1;
    this.load();
  }

  onPageChange(newPage: number) {
    if (newPage < 1 || newPage > this.totalPages) return;
    this.page = newPage;
    this.load();
  }

  get totalPages(): number {
    if (this.pageSize <= 0) return 0;
    return Math.max(1, Math.ceil(((this.result && this.result.totalCount) || 0) / this.pageSize));
  }

  openCreate() {
    this.isCreate = true;
    this.editingItem = null;
    this.formSigCode = '';
    this.formDescription = '';
    this.formIsDeleted = false;
    this.openModal('sigCodeModal');
  }

  openEdit(item: ISigCodeDto) {
    this.isCreate = false;
    this.editingItem = item;
    this.formSigCode = item.sigCode || '';
    this.formDescription = item.description || '';
    this.formIsDeleted = item.isDeleted || false;
    this.openModal('sigCodeModal');
  }

  save() {
    const sigCode = (this.formSigCode || '').trim();
    if (!sigCode) {
      this.showErrorMessage = true;
      this.errorMessage = 'Sig Code is required.';
      setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
      return;
    }
    if (this.isCreate) {
      this.sigCodeService.createSigCode({ sigCode, description: (this.formDescription || '').trim() }).subscribe({
        next: () => {
          this.closeModal('sigCodeModal');
          this.load();
          this.sharedService.showSuccessMessage = true;
        },
        error: (err) => {
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Create failed.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
        }
      });
    } else if (this.editingItem) {
      this.sigCodeService.updateSigCode(this.editingItem.id, {
        sigCode,
        description: (this.formDescription || '').trim(),
        isDeleted: this.formIsDeleted
      }).subscribe({
        next: () => {
          this.closeModal('sigCodeModal');
          this.load();
          this.sharedService.showSuccessMessage = true;
        },
        error: (err) => {
          this.showErrorMessage = true;
          this.errorMessage = (err && err.error && err.error.message) || (err && err.message) || 'Update failed.';
          setTimeout(() => { this.showErrorMessage = false; this.errorMessage = ''; }, 5000);
        }
      });
    }
  }

  openModal(modalId: string) {
    const el = document.getElementById(modalId);
    if (el) new bootstrap.Modal(el).show();
  }

  closeModal(modalId: string) {
    const el = document.getElementById(modalId);
    const modal = bootstrap.Modal.getInstance(el);
    if (modal) modal.hide();
  }
}
